module.exports = __webpack_public_path__ + "media/react/fonts/fa-solid-900-e4506c4b61b82db756882ce7e377bde5.woff";